import React, { useState } from "react";
import "../../../components/BirthdayCard.css";

export default function BirthdayCard({
  show = true,
  userName = "Happy Human",
  employeeId = "",
  department = "",
  message = "May your birthday bring smiles, happiness and many blessings. Happy Birthday! 🎉🎂"
}) {
  const [flipped, setFlipped] = useState(false);
  if (!show) return null;

  return (
    <div className="bd-row">
      <div
        className={`bd-card ${flipped ? "is-flipped" : ""}`}
        onClick={() => setFlipped((s) => !s)}  // tap to flip on mobile
        role="button"
        aria-label="Birthday card"
      >
        <div className="bd-back" />
        <div className="bd-front">
          <div className="bd-cover-lg">
            <div className="bd-shape bd-diamond" />
            <div className="bd-shape bd-block">
              <div className="bd-cake">
                <div className="bd-layer bd-bottom" />
                <div className="bd-layer bd-mid" />
                <div className="bd-layer bd-top" />
                <div className="bd-icing" />
                <div className="bd-drip bd-d1" />
                <div className="bd-drip bd-d2" />
                <div className="bd-drip bd-d3" />
                <div className="bd-candle">
                  <div className="bd-flame" />
                </div>
              </div>
            </div>
          </div>
          <div className="bd-cover-sm">
            <div className="bd-shape bd-diamond" />
            <div className="bd-shape bd-block" />
          </div>
        </div>

        <div className="bd-text">
          <p className="bd-head">
            {message}
            <br />
            <strong>{userName}</strong>
            {employeeId ? ` (${employeeId})` : ""}
            <br />
            {department}
          </p>
        </div>
      </div>
    </div>
  );
}
